// src/components/clients/ClientList.jsx

import React from "react";
import { FiUser, FiUserCheck, FiUserX } from "react-icons/fi";

function ClientList({ clients, onSelect }) {
  return (
    <div>
      {clients.length === 0 ? (
        <p className="text-gray-500">No clients found for the selected filter.</p>
      ) : (
        <ul className="space-y-2">
          {clients.map((client, index) => {
            const isActive = client.isActive !== false;
            const statusIcon = isActive ? FiUserCheck : FiUserX;
            const StatusIcon = statusIcon;
            
            return (
              <li
                key={client.id || index}
                onClick={() => onSelect(client)}
                className={`p-3 bg-white rounded shadow flex items-center justify-between hover:bg-gray-100 cursor-pointer transition border-l-4 ${
                  isActive ? 'border-green-400' : 'border-orange-400'
                }`}
              >
                <div className="flex items-center space-x-3">
                  <StatusIcon 
                    className={`w-5 h-5 ${isActive ? 'text-green-500' : 'text-orange-500'}`} 
                  />
                  <div>
                    <div className="flex items-center space-x-2">
                      <strong className={isActive ? 'text-gray-900' : 'text-gray-600'}>{client.name}</strong>
                      <span className={`px-2 py-1 rounded-full text-xs font-medium ${
                        isActive 
                          ? 'bg-green-100 text-green-800' 
                          : 'bg-orange-100 text-orange-800'
                      }`}>
                        {isActive ? 'Active' : 'Inactive'}
                      </span>
                    </div>
                    <span className="text-sm text-gray-600">{client.email}</span>
                    {!isActive && client.treatmentOutcome && (
                      <span className="text-xs text-gray-500 block mt-1">
                        Treatment completed: {client.treatmentOutcome.completedDate ? 
                          new Date(client.treatmentOutcome.completedDate).toLocaleDateString() : 'Unknown'}
                      </span>
                    )}
                  </div>
                </div>
                <span className="text-gray-400 text-lg ml-2">&rsaquo;</span>
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
}

export default ClientList;
